module.exports = __webpack_public_path__ + "static/media/contestdashboard-2.fa4b1fed.png";